export const pathResolver = (path , params) => {
    if(params === undefined){
        return path;
    }
    params.map(p => path = path.replace(":" + p.name + "?", p.value));
    return path;
}